let oldLoadUrl = Backbone.History.prototype.loadUrl;

Backbone.History.prototype.loadUrl = function () {
    this.previousFragment = this.fragment;
    oldLoadUrl.apply(this, arguments);
};

Backbone.History.prototype.revert = function () {
    this.navigate(this.previousFragment, { replace: true });
};
